module.exports = __webpack_public_path__ + "static/media/farming.16f3fbcf.svg";